// src/app/login/backend.ts
// Eigene Datei ohne Service-Bezug: wird von beiden Interceptors und dem
// LoginService gebraucht, ohne dass ein Import-Zyklus entsteht.
import { HttpContextToken } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** true, wenn der Aufruf an die eigene Backend-Basis geht (nur dann Schlüssel und Token). */
export function isOwnBackend(url: string): boolean {
  return url.startsWith(environment.backendUrl + '/');
}

/**
 * Aufruf darf bei 401 NICHT abmelden. Für die Übergabe an ein Werkzeug
 * (login.page.ts): dort wird auch ohne Auth-Parameter weitergeleitet.
 */
export const KEEP_SESSION_ON_401 = new HttpContextToken<boolean>(() => false);
